import { Skeleton } from "@mui/material";
import "./index.scss";

const CardShimmer = ({
  type = "stat",
  showTrend = false,
  showBreakdown = false,
  showSubLabel = false,
}) => {
  return (
    <div className="dashboard-card dashboard-card--loading">
      <div className="dashboard-card__header">
        <div className="dashboard-card__icon">
          <Skeleton
            variant="rectangular"
            width={48}
            height={48}
            className="card-shimmer"
          />
        </div>

        {/* Show trend shimmer for admin/lob cards */}
        {(showTrend || type === "lob") && (
          <div className="dashboard-card__trend">
            <Skeleton
              variant="text"
              width={60}
              height={20}
              className="card-shimmer"
            />
          </div>
        )}
      </div>

      <div className="dashboard-card__content">
        {/* Card title */}
        <Skeleton
          variant="text"
          width={120}
          height={16}
          className="card-shimmer"
        />

        {/* Card value - main number */}
        <Skeleton
          variant="text"
          width={100}
          height={36}
          className="card-shimmer"
          style={{ marginTop: "8px" }}
        />

        {/* Description or sub-label for cards that have additional info */}
        {!showBreakdown && !showSubLabel && (
          <Skeleton
            variant="text"
            width={150}
            height={14}
            className="card-shimmer"
            style={{ marginTop: "4px" }}
          />
        )}

        {/* Sub-label for cards like OPS and Client cards */}
        {showSubLabel && (
          <Skeleton
            variant="text"
            width={130}
            height={14}
            className="card-shimmer"
            style={{ marginTop: "8px" }}
          />
        )}

        {/* Breakdown items for cards that have them */}
        {showBreakdown && (
          <div
            className="dashboard-card__breakdown"
            style={{ marginTop: "12px" }}
          >
            <Skeleton
              variant="rectangular"
              width={80}
              height={24}
              className="card-shimmer breakdown-shimmer"
            />
            <Skeleton
              variant="rectangular"
              width={70}
              height={24}
              className="card-shimmer breakdown-shimmer"
            />
            <Skeleton
              variant="rectangular"
              width={90}
              height={24}
              className="card-shimmer breakdown-shimmer"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CardShimmer;
